/*
 * @Description: 
 * @Author: xiong.zhou@dmall.com
 * @Date: 2022-09-15 22:06:08
 * @LastEditors: xiong.zhou@dmall.com
 * @LastEditTime: 2022-09-15 22:34:24
 */
import request from '../request';

export function getSaleTotal(params) {
    return request('/sales/data/total', {
        method: 'get',
        params
    });
}

export function getSaleList(params) {
    return request('/sales/data/detail', {
        method: 'get',
        params
    });
}